import { render, staticRenderFns } from "./EntityHeader.vue?vue&type=template&id=bd238038&scoped=true&"
import script from "./EntityHeader.vue?vue&type=script&lang=ts&"
export * from "./EntityHeader.vue?vue&type=script&lang=ts&"
import style0 from "./EntityHeader.vue?vue&type=style&index=0&id=bd238038&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd238038",
  null
  
)

export default component.exports